"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var withStyles_1 = require("../styles/withStyles");

var createStyles_1 = require("../styles/createStyles");

var Collapse_1 = __importDefault(require("../Collapse"));

var Fade_1 = __importDefault(require("../Fade"));

var Grid_1 = __importDefault(require("../Grid"));

var Paper_1 = __importDefault(require("../Paper"));

var functions_1 = require("../libUtils/functions");

var util_1 = require("../styles/util");

var styles = function styles(_ref) {
  var palette = _ref.palette;
  return createStyles_1.createStyles({
    root: {
      width: 'auto',
      overflow: 'hidden',
      flexWrap: 'nowrap'
    },
    iconContainer: {
      alignSelf: 'stretch',
      width: 'auto',
      '& svg': {
        margin: '.33rem 0'
      }
    },
    messageContainer: {
      flexGrow: 1,
      alignSelf: 'center'
    },
    notificationContainer: {
      '&:focus': {
        outline: 'none',
        '& [class*="MuiPaper-root"]': {
          boxShadow: '0px 1px 8px 0px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 3px 3px -2px rgba(0,0,0,0.12), 0 0 3px 3px rgba(38, 101, 217, .5)'
        }
      }
    },
    typeDefault: {
      backgroundColor: palette.grey[200],
      color: palette.getContrastText(palette.grey[200])
    },
    typeSuccess: {
      backgroundColor: palette.success.main,
      color: palette.success.contrastText
    },
    typeInfo: {
      backgroundColor: palette.info.main,
      color: palette.info.contrastText
    },
    typeError: {
      backgroundColor: palette.error.main,
      color: palette.error.contrastText
    },
    transition: {
      overflow: 'visible'
    }
  });
};

var Notification = React.forwardRef(function (props, ref) {
  var classes = props.classes,
      className = props.className,
      children = props.children,
      _props$enableTransiti = props.enableTransition,
      enableTransition = _props$enableTransiti === void 0 ? false : _props$enableTransiti,
      _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      icon = props.icon,
      iconLabel = props.iconLabel,
      _props$type = props.type,
      type = _props$type === void 0 ? 'default' : _props$type,
      margin = props.margin,
      padding = props.padding,
      enter = props.enter,
      exit = props.exit,
      timeout = props.timeout,
      onEnter = props.onEnter,
      onEntering = props.onEntering,
      onEntered = props.onEntered,
      onExit = props.onExit,
      onExiting = props.onExiting,
      onExited = props.onExited,
      paperProps = __rest(props, ["classes", "className", "children", "enableTransition", "visible", "icon", "iconLabel", "type", "margin", "padding", "enter", "exit", "timeout", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited"]);

  var transitionProps = {
    enter: enter,
    exit: exit,
    timeout: timeout,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited
  };
  var rootClasses = clsx_1.default(classes.root, className);
  var iconContainerClasses = clsx_1.default(classes.iconContainer, classes["type" + functions_1.capitalize(type)]);
  var transitionSpacingClasses = clsx_1.default(util_1.createPaddingClassNames({
    padding: padding
  }), util_1.createMarginClassNames({
    margin: margin
  }));

  var componentProp = function componentProp(cProps) {
    return React.createElement(Grid_1.default, Object.assign({
      container: true,
      spacing: 0
    }, cProps));
  };

  var marginProp = !enableTransition ? margin : undefined;
  var paddingProp = !enableTransition ? padding : undefined;
  var notification = React.createElement(Paper_1.default, Object.assign({
    component: componentProp,
    elevation: 3,
    className: rootClasses,
    margin: marginProp,
    padding: paddingProp
  }, paperProps), React.createElement(Grid_1.default, {
    item: true,
    container: true,
    justify: "center",
    padding: 2,
    className: iconContainerClasses,
    "aria-label": iconLabel
  }, icon), React.createElement(Grid_1.default, {
    item: true,
    padding: {
      x: 3,
      y: 2
    },
    className: classes.messageContainer
  }, children));
  var transitionNotification = React.createElement(Collapse_1.default, Object.assign({
    timeout: {
      enter: 500,
      exit: 1000
    },
    in: visible,
    "aria-hidden": !visible,
    className: classes.transition,
    mountOnEnter: true,
    unmountOnExit: true
  }, transitionProps), React.createElement("div", {
    className: transitionSpacingClasses
  }, React.createElement(Fade_1.default, {
    timeout: {
      enter: 800,
      exit: 500
    },
    in: visible
  }, notification)));
  return React.createElement("div", {
    className: classes.notificationContainer,
    tabIndex: -1,
    ref: ref
  }, enableTransition && transitionNotification, !enableTransition && notification);
});
exports.default = withStyles_1.withStyles(styles, {
  name: 'UnifiNotification'
})(Notification);